/**
 *
 * InsuranceModal
 *
 */

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import Modal from '@material-ui/core/Modal';
import { makeSelectAuth, makeSelectProfile } from 'containers/Auth/selectors';
import { showInsuranceModal } from 'containers/Main/actions';
import {
  makeSelectClientDetails,
  makeSelectInsuranceModal,
} from 'containers/Main/selectors';
import useSiteConfigSelector from 'components/useSiteConfigSelector';
import { getLocalData } from 'utils/localDataStore';
import ModalContent from './components/ModalContent';

function InsuranceModal() {
  const dispatch = useDispatch();
  // const location = useLocation();
  const auth = useSelector(makeSelectAuth());
  const profile = useSelector(makeSelectProfile());
  const status = useSelector(makeSelectInsuranceModal());
  const clientDetails = useSelector(makeSelectClientDetails());
  const [siteConfig] = useSiteConfigSelector(['Insurance']);

  const isEnabled = _get(
    siteConfig,
    'config.onboardingEnabledClients',
    [],
  ).includes(_get(clientDetails, 'shortName'));

  useEffect(() => {
    // const splitPathname = location.pathname
    //   .split('/')
    //   .filter(item => Boolean(item));

    // const isResourcePage =
    //   [
    //     'topics',
    //     'videos',
    //     'apps',
    //     'podcasts',
    //     'books',
    //     'organizations',
    //     'services',
    //     'articles',
    //     'blogs',
    //     'faqs',
    //     'lists',
    //     'people',
    //     'programs',
    //     'insights',
    //   ].includes(splitPathname[0]) && splitPathname.length > 1;

    const hasInsuranceSet =
      (!profile.isEmpty && !_isEmpty(profile.insurance)) ||
      (profile.isEmpty && !_isEmpty(getLocalData('insurance')));

    // if (!isResourcePage && !hasInsuranceSet) {
    if (isEnabled && !hasInsuranceSet) {
      dispatch(
        showInsuranceModal({
          type: 'common',
        }),
      );
    }
  }, [isEnabled]);

  useEffect(() => {
    const hasInsuranceSet =
      (!profile.isEmpty && !_isEmpty(profile.insurance)) ||
      (profile.isEmpty && !_isEmpty(getLocalData('insurance')));

    if (
      isEnabled &&
      !auth.isEmpty &&
      !hasInsuranceSet &&
      Date.now() - auth.createdAt < 5 * 60 * 1000
    ) {
      dispatch(
        showInsuranceModal({
          type: 'sign-up',
        }),
      );
    }
  }, [auth, dispatch, isEnabled, profile]);

  return (
    <Modal open={status.visible}>
      <div>
        <ModalContent />
      </div>
    </Modal>
  );
}

export default InsuranceModal;
